import { t } from '@grafana/i18n';
import { Badge } from '@grafana/ui';

// Shown in place of the datasource name when a saved query's datasource can't be resolved (e.g. it was
// deleted). The tooltip reuses the detail banner copy so the badge alone explains why the row is broken.
export function BrokenDatasourceBadge() {
  return (
    <Badge
      color="red"
      icon="times-circle"
      text={t('saved-queries.card.datasource-broken', 'Data source broken')}
      tooltip={t(
        'saved-queries.details.load-error-title',
        "The data source for this query may have been deleted. This query can't be used - create a new saved query."
      )}
    />
  );
}
